import { Button, IconButton } from "@spz/ui/components/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@spz/ui/components/tooltip";
import { cn } from "../../../lib/utils";
import type { ButtonCellProps } from "../types";

export const ButtonCell: React.FC<ButtonCellProps> = ({
  buttons = [], // Default empty array
  className,
  alignment = "right",
}) => {
  const validButtons = buttons?.filter(
    (btn) =>
      btn && typeof btn === "object" && "type" in btn && "onClick" in btn,
  );

  const renderButton = (btn: ButtonCellProps["buttons"][0], index: number) => {
    if (!btn || !btn.type || !btn.onClick) {
      return null;
    }

    const buttonContent =
      btn.type === "button" ? (
        <Button
          variant={btn.variant}
          onClick={btn.onClick}
          leftIcon={btn.leftIcon}
          rightIcon={btn.rightIcon}
          disabled={btn.disabled}
          className={btn.className}
          ghostInTableCell={btn.variant === "ghost"}
        >
          {btn.label}
        </Button>
      ) : (
        <IconButton
          variant={btn.variant}
          icon={btn.icon}
          onClick={btn.onClick}
          showCornerAccent={btn.showCornerAccent}
          disabled={btn.disabled}
          className={btn.className}
          ghostInTableCell={btn.variant === "ghost"}
        />
      );

    if (
      (btn.type === "icon" && btn.label) ||
      (btn.type === "button" && btn.icon)
    ) {
      return (
        <Tooltip key={index}>
          <TooltipTrigger asChild>{buttonContent}</TooltipTrigger>
          <TooltipContent>{btn.label}</TooltipContent>
        </Tooltip>
      );
    }

    return buttonContent;
  };

  return (
    <div
      className={cn(
        "flex gap-4 items-center",
        {
          "justify-start": alignment === "left",
          "justify-center": alignment === "center",
          "justify-end": alignment === "right",
        },
        className,
      )}
    >
      {validButtons?.map((btn, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        <div key={index}>{renderButton(btn, index)}</div>
      ))}
    </div>
  );
};
